import"react";import e from"./defaultTheme.js";import m from"./identifier.js";import t from"../node_modules/@mui/system/esm/useTheme.js";function o(){const o=t(e);return o[m]||o}export{o as default};
//# sourceMappingURL=useTheme.js.map
